import React from "react";
import styled from "styled-components";
import { IonItem } from "@ionic/react";

const Alert = styled(IonItem)`
  font-size: 0.9em;
`;

export default (props) => {
  return <Alert {...props}>{props.children}</Alert>;
};
